var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex container-fluid"},[_c('div',{staticClass:"pane left-pane",style:({ width: _vm.leftWidth + 'px' })},[_vm._t("left")],2),_c('div',{staticClass:"splitter",on:{"mousedown":_vm.startResize,"touchstart":_vm.startResize}}),_c('div',{staticClass:"pane right-pane"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }